const DB_NAME = "forsteinntrykk-product-drafts";
const DB_VERSION = 1;
const STORE_NAME = "drafts";

const openDraftDb = () =>
  new Promise((resolve, reject) => {
    if (!("indexedDB" in window)) {
      reject(new Error("IndexedDB is not available"));
      return;
    }

    const request = window.indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: "id" });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

const runStoreOperation = async (mode, operation) => {
  const db = await openDraftDb();

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, mode);
    const store = tx.objectStore(STORE_NAME);
    const request = operation(store);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    tx.oncomplete = () => db.close();
    tx.onerror = () => {
      db.close();
      reject(tx.error);
    };
  });
};

export const getProductDrafts = () =>
  runStoreOperation("readonly", (store) => store.getAll()).catch(() => []);

export const saveProductDraft = (draft) =>
  runStoreOperation("readwrite", (store) => store.put(draft));

export const deleteProductDraft = (id) =>
  runStoreOperation("readwrite", (store) => store.delete(id));

export const clearProductDrafts = () =>
  runStoreOperation("readwrite", (store) => store.clear());
